@if (meta(); as pagination) {
  @if (pagination.last_page > 1) {
    <nav class="pagination" aria-label="Pagination">
      @if (currentPage > 1) {
        <kin-btn
          class="pagination-btn pagination-nav"
          color="primary"
          size="small"
          (onClick)="goToPage(1)">
          <kin-icon
            class="pagination-icon"
            name="arrow_left_block"
            [color]="navigationIconColor()"
            [relativeSize]="true" />
        </kin-btn>
      }

      @for (item of pages(); track item.id) {
        <kin-btn
          class="pagination-btn"
          [class.pagination-btn-active]="item.page === currentPage"
          color="primary"
          size="small"
          [disabled]="item.page === currentPage"
          (onClick)="goToPage(item.page)">
          {{ item.label }}
        </kin-btn>
      }

      @if (currentPage < lastPage) {
        <kin-btn
          class="pagination-btn pagination-nav"
          color="primary"
          size="small"
          (onClick)="goToPage(lastPage)">
          <kin-icon
            class="pagination-icon"
            name="arrow_right_block"
            [color]="navigationIconColor()"
            [relativeSize]="true" />
        </kin-btn>
      }
    </nav>
  }
}
